module.exports = __webpack_public_path__ + "img/actiefwerkt.d47c51dc.svg";